import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { listPaletteApi, addPaletteApi } from "../../auth/authService";

export const fetchMasterPallete = createAsyncThunk(
    "masterPallete/fetchMasterPallete",
    async (params = {}, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.token;

            const {
                page = 1,
                per_page = 10,
                search = ""
            } = params;

            const res = await listPaletteApi(token, {
                page,
                per_page,
                search
            });

            return res;
        } catch (err) {
            console.log("ERROR:", err);
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil data"
            );
        }
    }
);


export const createMasterPallete = createAsyncThunk(
    "masterPallete/create",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await addPaletteApi(payload);
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

const masterPalleteSlice = createSlice({
    name: "masterPallete",
    initialState: {
        data: [],
        pagination: {},
        loading: false,
        error: null,
    },
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchMasterPallete.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMasterPallete.fulfilled, (state, action) => {
                //console.log("FULLFILLED PAYLOAD:", action.payload);
                state.loading = false;
                state.data = action.payload.data;
                state.pagination = action.payload.pagination; 
                //console.log("PAYLOAD:", action.payload);
            })
            .addCase(fetchMasterPallete.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                //console.log("REJECTED:", action.payload);
            })
            .addCase(createMasterPallete.fulfilled, (state, action) => {
                if (action.payload?.data) {
                    state.data.unshift(action.payload.data);
                }
            });
    },
});

export default masterPalleteSlice.reducer;